function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16.895 4.37A8.508 8.508 0 0 0 4.568 7.727a.5.5 0 0 1-.67.23.5.5 0 0 1-.21-.65 9.498 9.498 0 0 1 13.906-3.635l1.443-1.441a.787.787 0 0 1 1.113 0l1.622 1.643a.793.793 0 0 1-.007 1.12l-1.49 1.486A9.5 9.5 0 0 1 4.477 17.017l-.469 2.64a.508.508 0 1 1-1-.18l.84-4.07v-.08l.05-.09v-.06l.09-.07h.29l3.94.7a.507.507 0 0 1-.17 1l-2.85-.51a8.508 8.508 0 0 0 14.364-9.104l-6.203 6.192v-.001l-2.907.608a.377.377 0 0 1-.443-.45l.626-2.92 6.26-6.252zm.945.724l-6.13 6.122-.292 1.364 1.359-.284h.001l6.106-6.099a8.533 8.533 0 0 0-1.044-1.103zm.689-.688c.378.338.73.705 1.05 1.098l1.077-1.076-1.067-1.081-1.06 1.06zm-6.591 5.912l1.814 1.84.835-.835-1.813-1.84-.836.835z"
});

var SvgMaterialStory = function SvgMaterialStory(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMaterialStory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MaterialStory.15a8f11d.svg";
export { ForwardRef as ReactComponent };